import { axiosInstance } from "./index";
import { ApiResponse } from "./types";
import { ApiRequest } from "./types";

export const getAnnouncements = async (params: ApiRequest.GetAnnouncements) => {
  const response = await axiosInstance.get<ApiResponse.Announcements>(
    `/api/v1/announcements`,
    {
      params
    }
  );
  return response;
};
